import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-notice",
  "use": "icon-notice-usage",
  "viewBox": "0 0 24 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 25\" id=\"icon-notice\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M-2-2h28v28H-2z\" /><path d=\"M21.333 17.833h2.334v2.334H.333v-2.334h2.334V9.667a9.333 9.333 0 1 1 18.666 0v8.166Zm-2.333 0V9.667a7 7 0 0 0-14 0v8.166h14ZM8.5 22.5h7v2.333h-7V22.5Z\" fill=\"#B3B3B3\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol